export const EXTERNAL_DOMAINS = {
  CANVAS: "https://pgaofamerica.instructure.com",
  EVENTS: "https://events.pga.org",
  EXTRANET: "https://extranet.pgalinks.com",
  LEGACY_APPS: "https://apps.pga.org/professionals/apps/education",
  GOOGLE_MAPS: "https://www.google.com/maps",
}

// Requirement code mappings for Canvas SIS course IDs
// Format: {level_code}-{level_code}{requirement_code}-PGA
export const REQUIREMENT_CODES = {
  qualifying: {
    course_manuals: "CSWRK",
  },
  level1: {
    course_manuals: "CSWRK",
    portfolio: "PORTFO",
    portfolio_afm: "AFMPRT",
    portfolio_tc: "ATCPRT",
    virtual_seminar: "SEMINA",
  },
  level2: {
    course_manuals: "CSWRK",
    portfolio: "PORTFO",
    seminar: "SEMINA",
  },
  level3: {
    course_manuals: "CSWRK",
    portfolio: "PORTFO",
    seminar: "SEMINA",
    // Final exam is stored in TEST tables (pga.cd_gptptest), not requirements tables
    final_exam: "TEST",
  },
}

export const buildCanvasSisUrl = (levelCode, requirementCode) => {
  if (!levelCode || !requirementCode) return CANVAS_URLS.HOME

  const sisId = `${levelCode}-${levelCode}${requirementCode}-PGA`
  return `${EXTERNAL_DOMAINS.CANVAS}/courses/sis_course_id:${sisId}`
}

export const getRequirementCode = (level, requirementType) => {
  const levelCodes = REQUIREMENT_CODES[level]
  if (!levelCodes) return null

  const reqCode = levelCodes[requirementType]

  if (!reqCode) return null

  return reqCode
}

export const buildCanvasUrlForRequirement = (
  level,
  levelCode,
  requirementType,
) => {
  const requirementCode = getRequirementCode(level, requirementType)

  if (!requirementCode) return CANVAS_URLS.HOME

  return buildCanvasSisUrl(levelCode, requirementCode)
}

export const CANVAS_URLS = {
  // Base portal access
  HOME: EXTERNAL_DOMAINS.CANVAS,

  // Course listings
  COURSES: `${EXTERNAL_DOMAINS.CANVAS}/courses`,
  VIRTUAL_SEMINAR_CONFERENCE: `${EXTERNAL_DOMAINS.CANVAS}/courses/462/conferences`,
}

export const EVENTS_URLS = {
  // Base events page
  HOME: EXTERNAL_DOMAINS.EVENTS,

  // My Events dashboard
  MY_EVENTS: `${EXTERNAL_DOMAINS.EVENTS}/my-events`,

  // Search configurations (use with interpolate for timestamps)
  PAT_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true`,

  EDUCATION_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Education`,

  VIRTUAL_SEMINAR_L1_SEARCH: `${EXTERNAL_DOMAINS.EVENTS}/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&query=virtual%20seminar%20level%201`,
}

export const LEGACY_APP_URLS = {
  // Level registrations (use with interpolate for {{curriculumCode}} and {{pgaId}})
  // curriculumCode examples: 'pgapgm30' for v3.0, 'pgapgm31' for v3.1
  LEVEL_2_REGISTRATION: `${EXTERNAL_DOMAINS.LEGACY_APPS}/{{curriculumCode}}/level2reg.cfm?entity_id={{pgaId}}`,
  LEVEL_3_REGISTRATION: `${EXTERNAL_DOMAINS.LEGACY_APPS}/{{curriculumCode}}/level3reg.cfm?entity_id={{pgaId}}`,
}

export const getCurriculumCode = version => {
  const versionMap = {
    "3.0": "pgapgm30",
    3.1: "pgapgm31",
  }

  if (!version || !versionMap[version]) {
    console.error(
      `[getCurriculumCode] Unsupported curriculum version: "${version}". Expected "3.0" or "3.1". Defaulting to "3.1"`,
    )
    return "pgapgm31"
  }

  return versionMap[version]
}

export const EXTRANET_URLS = {
  // Member event history (use with interpolate for {{pgaId}})
  EVENT_HISTORY: `${EXTERNAL_DOMAINS.EXTRANET}/pat/evtssaparthist.display_history?p_cust_id={{pgaId}}`,
}

export const MAP_URLS = {
  // PGA Headquarters in Frisco, TX - 1916 PGA Pkwy, Frisco, TX 75034
  PGA_HQ: `${EXTERNAL_DOMAINS.GOOGLE_MAPS}/place/1916+PGA+Pkwy,+Frisco,+TX+75034`,
}

export const MY_PGA_URLS = {
  // Invoices page / tab - used for Level 1 purchase CTA
  INVOICES: "https://my.pga.com/member/account/invoices?slug=invoices",
}
